import { classNames } from "../utilities"
import { ArrowLeftIcon, ArrowRightIcon } from "@heroicons/react/outline"
import { CSSProperties } from "react"
import { Carousel } from "react-responsive-carousel"

interface Testimonial {
  companyLogo: string | null
  review: string
  name: string
  title: string
}

interface Props {
  testimonials: Testimonial[]
}

export default function TestimonialCarousel({ testimonials }: Props) {
  // const TestimonialGroups = chunk(testimonials, 1)
  const arrowStyles: CSSProperties = {
    position: "absolute",
    zIndex: 2,
    top: "calc(50% - 15px)",
    width: 30,
    height: 30,
    cursor: "pointer",
  }
  return (
    <section className="bg-white">
      <div className="mx-auto max-w-7xl px-6 lg:px-8">
        <Carousel
          className="mt-4"
          showStatus={false}
          showArrows
          showIndicators
          infiniteLoop
          autoPlay
          interval={15000}
          renderArrowPrev={(onClickHandler, hasPrev, label) =>
            hasPrev && (
              <button
                type="button"
                onClick={onClickHandler}
                title={label}
                style={{ ...arrowStyles, left: 15 }}
                className="hidden lg:block"
              >
                <ArrowLeftIcon className="text-primary" />
              </button>
            )
          }
          renderArrowNext={(onClickHandler, hasNext, label) =>
            hasNext && (
              <button
                type="button"
                onClick={onClickHandler}
                title={label}
                style={{ ...arrowStyles, right: 15 }}
                className="hidden lg:block"
              >
                <ArrowRightIcon className="text-primary" />
              </button>
            )
          }
          renderIndicator={(
            clickHandler: (e: React.MouseEvent | React.KeyboardEvent) => void,
            isSelected: boolean
          ) => (
            <button
              onClick={clickHandler}
              type="button"
              className={classNames(
                isSelected ? "bg-primary" : "bg-white",
                "mx-1 w-2 h-2 ring-1 ring-primary rounded-full"
              )}
            />
          )}
        >
          {testimonials.map((testimonial, index) => (
            <section
              key={index}
              className="relative isolate overflow-hidden bg-white px-6 py-16 lg:px-8"
            >
              <div className="absolute inset-0 -z-10 bg-[radial-gradient(45rem_50rem_at_top,theme(colors.indigo.100),white)] opacity-20" />
              <div className="absolute inset-y-0 right-1/2 -z-10 mr-16 w-[200%] origin-bottom-left skew-x-[-30deg] bg-white shadow-xl shadow-indigo-600/10 ring-1 ring-indigo-50 sm:mr-28 lg:mr-0 xl:mr-16 xl:origin-center" />
              <div className="mx-auto max-w-2xl lg:max-w-4xl">
                {testimonial.companyLogo && (
                  <img
                    className="mx-auto max-w-[8rem]"
                    src={testimonial.companyLogo}
                    alt=""
                  />
                )}
                <figure className="mt-10">
                  <blockquote
                    className={classNames(
                      "text-center font-semibold leading-8 text-gray-900 sm:leading-9",
                      testimonial.title.includes("NuBrakes")
                        ? "text-sm sm:text-base"
                        : "text-lg sm:text-xl"
                    )}
                  >
                    <p>“{testimonial.review}”</p>
                  </blockquote>
                  <figcaption className="mt-10">
                    {/* <img
                    className="mx-auto h-10 w-10 rounded-full"
                    src="https://images.unsplash.com/photo-1494790108377-be9c29b29330?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80"
                    alt=""
                  /> */}
                    <div className="mt-4 flex items-center justify-center space-x-2 text-base">
                      <div className="font-semibold text-gray-900">
                        {testimonial.name}
                      </div>
                      <svg
                        viewBox="0 0 2 2"
                        width={3}
                        height={3}
                        aria-hidden="true"
                        className="fill-primary"
                      >
                        <circle cx={1} cy={1} r={1} />
                      </svg>
                      <div className="text-gray-600">{testimonial.title}</div>
                    </div>
                  </figcaption>
                </figure>
              </div>
            </section>
          ))}
        </Carousel>
      </div>
    </section>
  )
}
